var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 165,
    viewBox: "0 0 177 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8927 159.869C7.46364 159.869 5.22145 154.536 8.31996 151.371L65.5532 92.9135C68.6874 89.7123 74.1259 91.9314 74.1259 96.4114V117.855C74.1259 120.616 76.3645 122.855 79.1259 122.855H132.017C134.778 122.855 137.017 120.616 137.017 117.855V39.623C137.017 38.3353 137.514 37.0973 138.404 36.1668L164.387 9.00421C167.503 5.74646 173 7.95218 173 12.4604V139.869C173 150.915 164.046 159.869 153 159.869H11.8927Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.886 4.80566C169.317 4.80566 171.558 10.1438 168.455 13.3072L111.088 71.7827C107.952 74.979 102.519 72.7588 102.519 68.2812V46.8202C102.519 44.0588 100.28 41.8202 97.5188 41.8202H44.7151C41.9537 41.8202 39.7151 44.0588 39.7151 46.8202V125.054C39.7151 126.341 39.2193 127.578 38.3307 128.508L12.3978 155.656C9.28259 158.917 3.78223 156.712 3.78223 152.202L3.78223 24.8057C3.78223 13.76 12.7365 4.80566 23.7822 4.80566L164.886 4.80566Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.857 4.80566C169.293 4.80566 171.532 10.1522 168.421 13.3132L100.472 82.3425C96.8267 86.0459 90.6518 82.4201 92.1097 77.4322L100.647 48.223C101.583 45.0224 99.1827 41.8202 95.8481 41.8202H44.7151C41.9537 41.8202 39.7151 44.0588 39.7151 46.8202V83.3263C39.7151 84.6128 39.2193 85.8497 38.3307 86.78L12.3978 113.928C9.28259 117.189 3.78223 114.984 3.78223 110.474L3.78223 24.8057C3.78223 13.76 12.7365 4.80566 23.7822 4.80566H164.857Z",
    fill: "#F6C52F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9211 159.869C7.48796 159.869 5.24757 154.527 8.35432 151.365L75.1134 83.4098C78.7198 79.7387 84.8516 83.2537 83.5063 88.221L75.8342 116.547C74.9733 119.726 77.3671 122.855 80.6603 122.855H132.017C134.778 122.855 137.017 120.616 137.017 117.855V88.7955C137.017 87.5078 137.514 86.2698 138.404 85.3393L164.387 58.1767C167.503 54.9189 173 57.1247 173 61.6329L173 139.869C173 150.915 164.046 159.869 153 159.869L11.9211 159.869Z",
    fill: "#C75E18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 172.188,
    y1: 32.8206,
    x2: 162.165,
    y2: 20.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#C75E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D60",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5.01865,
    y1: 131.869,
    x2: 16.418,
    y2: 147.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#F6C52F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCbIcon);
export default __webpack_public_path__ + "static/media/new_CB_icon.a014e5cdbb6712f9f1641b320a107d6b.svg";
export { ForwardRef as ReactComponent };